import React from "react"

import Layout from "../components/Layout"
import SEO from "../components/seo"
import About from "../components/About"
import JobExperience from "../components/JobExperience"
import Skills from "../components/Skills"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import "../utils/fontAwesome"

const StyledContainer = styled.div`
  max-width: 900px;
  margin: auto;
  padding-top: 105px;
  @media (max-width: 576px) {
    padding-top: 40px;
  }
`

const IndexPage = () => {
  const {
    avatar: {
      childImageSharp: { fluid: avatarFluid },
    },
  } = useStaticQuery(
    graphql`
      query {
        avatar: file(relativePath: { eq: "ava_ng.jpeg" }) {
          childImageSharp {
            fluid(maxWidth: 250, maxHeight: 350) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  return (
    <Layout avatar={avatarFluid}>
      <SEO avatar={avatarFluid} />
      <StyledContainer>
        <About />
        <JobExperience />
        <Skills />
      </StyledContainer>
    </Layout>
  )
}

export default IndexPage
